export default __webpack_public_path__ + "static/media/Attendants.51f67bb2.svg";